export default warehouseId => (
  window.open(`${process.env.API_LOCATION}/adjustments/${warehouseId}/download/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/downloadProduct.js